export enum ServiceFeatureTypes {
    BOOKING_CALENDAR = 'BOOKING_CALENDAR',
    GO_STUDENT = 'GO_STUDENT',
    GOOGLE_REVIEWS = 'GOOGLE_REVIEWS',
    SPECIALIZATIONS_PROMO = 'SPECIALIZATIONS_PROMO',
    EXACT_LOCATION = 'CUSTOMIZED_LOCATION'
}

export enum ServiceFeatureSubtypes {
    NONE = 'NONE',
    BASIC_CALENDAR = 'BASIC_CALENDAR',
    AVAILABILITY_CALENDAR = 'AVAILABILITY_CALENDAR',
    GO_STUDENT = 'GO_STUDENT',
    SPECIALIZATIONS_PROMO = 'SPECIALIZATIONS_PROMO',
    EXACT_LOCATION = 'CUSTOMIZED_LOCATION'
}

export enum ServiceFeatureUnits {
    NONE = 'NONE',
    DAYS = 'DAYS',
    NIGHTS = 'NIGHTS'
}

export enum SFCEndpoint {
    CONFIG = 'config',
    PREFERENCES = 'preferences'
}

export enum LocationTypes {
    EXACT = 'exact',
    GENERAL = 'general'
}

export type GeneratedFeaturesType = {
    featureType: ServiceFeatureTypes;
    type: ServiceFeatureSubtypes;
    unit: ServiceFeatureUnits;
    guestsEnabled: boolean;
    specializationsPromoEnabled: boolean;
};

export type PreferencesType = {
    bookingCalendar: {
        enabled: boolean;
    };
    location: {
        type: LocationTypes;
        address: {
            city: string;
            district: string;
            postalCode: string;
            street: string;
            buildingNo: string;
            details: string;
        };
    };
};

export type ServiceFeaturesConfigResponse = {
    platform: string;
    features: Record<string, GeneratedFeaturesType>;
    categories: Record<string, Array<string>>;
};

export type ServiceFeaturesOfferIdResponse = {
    platform: string;
    offerID: string;
    features: GeneratedFeaturesType[];
};

export type ServicePreferencesOfferIdResponse = {
    offerID: string;
    preferences: PreferencesType;
};

export type SFCBookingCalendarType = {
    renderAvailabilityCalendar: boolean;
    isShortTermRentals: boolean;
    isItemRentals: boolean;
    isGuestsFeatureEnabled: boolean;
};
